import type { ReactNode } from 'react';
import './LiksPhotoPreview.css';

export type LiksPhotoPreviewProps = {
  src: string | null;
  isLoading?: boolean;
  loadingLabel: string;
  placeholder: ReactNode;
  className?: string;
  imageClassName?: string;
  placeholderClassName?: string;
};

export function LiksPhotoPreview({
  src,
  isLoading = false,
  loadingLabel,
  placeholder,
  className,
  imageClassName,
  placeholderClassName,
}: LiksPhotoPreviewProps) {
  const rootClassName = ['liks-photo-preview', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={
        isLoading
          ? `${rootClassName} liks-photo-preview--loading`
          : rootClassName
      }
      aria-busy={isLoading || undefined}
    >
      {src ? (
        <img
          className={['liks-photo-preview__image', imageClassName]
            .filter(Boolean)
            .join(' ')}
          src={src}
          alt=""
        />
      ) : (
        <div
          className={['liks-photo-preview__placeholder', placeholderClassName]
            .filter(Boolean)
            .join(' ')}
        >
          {placeholder}
        </div>
      )}
      {isLoading && (
        <div className="liks-photo-preview__overlay">
          <div className="liks-photo-preview__spinner" aria-hidden />
          <span className="liks-photo-preview__loading-label">
            {loadingLabel}
          </span>
        </div>
      )}
    </div>
  );
}
